{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "القوالب",
    "DESCRIPTION": "استعرض قوالب الرسائل التي تمت مزامنتها من صناديق الوارد الخاصة بواتساب لديك. لإنشاء قالب أو تعديله، قم بإدارته لدى مزوّدك.",
    "COUNT": "عدد القوالب: {n}",
    "LEARN_MORE": "تعلم المزيد حول قوالب الواتساب",
    "SYNC_TEMPLATES": "مزامنة القوالب",
    "SYNC_SUCCESS": "بدأت مزامنة القوالب لجميع صناديق الوارد الخاصة بواتساب. قد تستغرق التحديثات بضع دقائق.",
    "PARTIAL_SYNC_ERROR": "بدأت مزامنة القوالب لبعض صناديق الوارد الخاصة بواتساب، لكن تعذرت مزامنة صناديق أخرى.",
    "SYNC_ERROR": "تعذر بدء مزامنة القوالب، الرجاء المحاولة مرة أخرى",
    "SEARCH_PLACEHOLDER": "البحث حسب المحتوى أو الاسم...",
    "MANAGE_IN_META": "الإدارة عبر Meta",
    "LOADING": "جاري جلب قوالب الواتساب...",
    "EMPTY": "لم يتم العثور على أي قوالب واتساب.",
    "NO_RESULTS": "لا توجد قوالب تطابق عوامل التصفية الخاصة بك.",
    "FETCH_ERROR": "تعذر تحميل قوالب واتساب، الرجاء المحاولة مرة أخرى",
    "PARTIAL_FETCH_ERROR": "تعذر تحميل بعض قوالب واتساب، الرجاء المحاولة مرة أخرى",
    "LAST_SYNC_ATTEMPT": "آخر محاولة مزامنة في {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "غير مُرسل للموافقة من واتساب"
    },
    "FILTERS": {
      "ALL_INBOXES": "جميع صناديق الوارد",
      "ALL_LANGUAGES": "جميع اللغات",
      "ALL_TYPES": "جميع الأنواع"
    },
    "TYPES": {
      "TEXT": "نص",
      "IMAGE": "صورة",
      "VIDEO": "فيديو",
      "DOCUMENT": "مستند",
      "CALL_TO_ACTION": "دعوة لاتخاذ إجراء",
      "COPY_CODE": "نسخ الرمز"
    },
    "PREVIEW": {
      "TITLE": "معاينة القالب",
      "DESCRIPTION": "عاين كيف يظهر هذا القالب في واتساب.",
      "OPEN": "معاينة {name}",
      "CLOSE": "إغلاق المعاينة",
      "DETAILS": "تفاصيل القالب",
      "STATUS": "الحالة",
      "TYPE": "نوع المحتوى",
      "CATEGORY": "الفئة",
      "LANGUAGE": "اللغة",
      "INBOXES": "صناديق الوارد"
    }
  }
}
